import Swiper from "swiper/swiper-bundle";
import GLightbox from "glightbox";

export default {
  init() {
    const slideshow = new Swiper(".slideshow.swiper", {
      loop: true,
      navigation: {
        nextEl: "",
        prevEl: "",
        clickable: true,
      },
    });

    const developer = new Swiper(".developer .swiper", {
      loop: false,
      slidesPerView: 2,
      slidesPerGroup: 2,
      grid: {
        rows: 2,
      },
      spaceBetween: 8,
      navigation: {
        nextEl: ".developer-button-next",
        prevEl: ".developer-button-prev",
        clickable: true,
      },
      breakpoints: {
        576: {
          spaceBetween: 20,
          slidesPerView: 3,
          slidesPerGroup: 3,
        },

        768: {
          spaceBetween: 20,
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        992: {
          spaceBetween: 30,
          slidesPerView: 5,
          slidesPerGroup: 5,
        },
        1200: {
          spaceBetween: 30,
          slidesPerView: 6,
          slidesPerGroup: 6,
        },
      },
    });

    const testimonial = new Swiper(".testimonial .swiper", {
      loop: false,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 30,
      spaceBetween: 0,
      navigation: {
        nextEl: ".testimonial-button-next",
        prevEl: ".testimonial-button-prev",
        clickable: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 30,
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        1200: {
          spaceBetween: 30,
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
      },
    });

    const lightbox = GLightbox({
      selector: ".glightbox",
    });
  },
  finalize() {},
};
